import { makeHttpRequest } from "@/shared";

export const deleteDeposits = async (ids) => {
    return (
        await makeHttpRequest({
            url: "/rent/deposit/delete-multiple",
            method: "DELETE",
            params: { items: ids },
        })
    ).data;
};
